import { Close } from '@mui/icons-material';
import { Button, CircularProgress, MenuItem, Select } from '@mui/material';
import React from 'react';
import { MultiFileUploadWizard } from '../../../components/UI-Elements/FileUpload/AttachFileScreen/components/MultiFileUploadWizard';
import {
  uploadFilesToServer,
  fetchDocumentsFromStorage,
} from '../../../components/UI-Elements/FileUpload/fileUploadUtils';
import { updateFileBatch } from '../../../sp-firebase/fileBatchesFB';
import { IFileBatch } from '../../../sp-types';
import { UploadManageFiles } from '../../UploadManageFiles/UploadManageFiles';
import { OverlayDisplayDiv } from '../../../components/UI-Elements/PopoverOverlays/OverlayDisplayDiv';

const BUCKET_NAME = 'DocumentBatches/';

export const BatchFileEditor: React.FC<{ options: any; accountId: string }> = ({ options, accountId }) => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [seePopup, setSeePopup] = React.useState<boolean>(options.seePopup || false);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    setLoading(true);
    const file = e.target.files?.[0];
    if (e.target.files && file) {
      const filesPath = await uploadFilesToServer(
        Array.from(e.target.files),
        `${BUCKET_NAME}${accountId}/${options.createdAt?.toDate().toLocaleDateString('en-CA')}-${options.id}/`,
        '',
      );

      const uploadedUrls = await fetchDocumentsFromStorage(filesPath, () => null);
      const resultFile = {
        id: 'results',
        path: filesPath?.[0] || '',
        url: uploadedUrls?.[0] || '',
        name: file.name,
      };
      options.resultFile = resultFile;

      await updateFileBatch(accountId, options.id, { resultFile });
    }
    setLoading(false);
  };

  const saveBatch = async (batchData: Partial<IFileBatch>) => {
    setLoading(true);
    await updateFileBatch(accountId, options.id, batchData);
    options.status = batchData.status;
    setLoading(false);
  };

  React.useEffect(() => {
    if (seePopup !== undefined) {
      options.seePopup = seePopup;
    }
  }, [seePopup]);

  return (
    <div>
      {!seePopup && (
        <Button variant="outlined" onClick={() => setSeePopup(true)}>
          See batch
        </Button>
      )}
      {seePopup && (
        <OverlayDisplayDiv setDisplayOverlay={() => setSeePopup(false)}>
          <div className="border rounded flex flex-col bg-white p-3 gap-2">
            <div className="absolute top-1 right-4 z-10 p-1 w-10">
              <Button onClick={() => setSeePopup(false)} className="flex">
                <Close />
              </Button>
            </div>

            <h3 className="flex flex-1 text-center">
              batch: {options?.id} ({options?.createdAt.toDate().toLocaleDateString('en-CA')})
            </h3>
            <div className="border-1 shadow-custom">
              <UploadManageFiles
                userId="admin"
                accountId={accountId}
                batchId={options.id}
                navigate={(url: string) => console.log('navigating to id: ', url.replace('/upload-files/', ''))}
                status={options.status}
              />
            </div>
            <div className="flex items-center justify-around gap-3 p-2 my-2 border">
              <p>current status:</p>
              <Select
                value={options.status}
                onChange={({ target }) => saveBatch({ status: target.value })}
                className="text-green-300"
                sx={{ color: '#4ACB3E', height: '2rem' }}
              >
                {['draft', 'pending', 'edit', 'done'].map((status, index) => (
                  <MenuItem key={index} id={status} value={status}>
                    {status}
                  </MenuItem>
                ))}
              </Select>
            </div>
            <div className="p-2 border">
              <h5>Upload results excel</h5>
              <input type="file" onChange={handleFileChange} />
              <hr />
              {options.resultFile && (
                <div onClick={() => window.open(options.resultFile.url)} className="flex gap-2">
                  file name: <p className="text-blue-600">{options.resultFile.name}</p>
                </div>
              )}
            </div>
            {loading && <CircularProgress size={64} className="absolute self-center top-28 text-blue-600" />}
          </div>
        </OverlayDisplayDiv>
      )}
    </div>
  );
};
